// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard-container {
  margin-bottom: 0px;
  margin-top: 20px;
  display: flex;
}

.dashboard-name {
  margin-left: 5px;
  font-size: 16px;
  font-weight: 500;
}

.admin-dashboard-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.admin-dashboard-header-content {
  font-size: 20px;
  font-weight: 400;
  padding-left: 0px;
  /* margin-top: 10px; */
}

.admin-dashboard-signup-banner-toggle {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 14px;
  font-weight: 400;
  color: #1976d2;
}

.admin-dashboard-signup-banner-toggle:hover {
  cursor: pointer;
  color: #1976d2;
}

.admin-dashboard-search {
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
}

.admin-dashboard-support-container {
  margin-top: 20px;
}

.request-support-link {
  color: rgb(0 151 215);
  font-weight: 500;
}

.alert-container {
  margin-top: 20px;
}

.table-cell-trucate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 30px;
  font-size: 12px;
}

.table-cell-trucate-reason {
  /* white-space: nowrap;
    overflow: hidden; */
  padding-left: 30px;
  font-size: 12px;
}

.table-cell-trucate-expand {
  white-space: nowrap;
  overflow: hidden;
  padding-left: 10px;
  font-size: 12px;
  color: blue;
}

.table-cell-trucate-expand:hover {
  cursor: pointer;
  text-decoration: underline;
}

.table-cell-trucate-email {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
}

.orgName-column-header {
  padding-left: 40px !important;
}

.MuiDataGrid-cell {
  font-size: 14px !important;
}

.MuiStepLabel-label {
  font-size: 14px !important;
}

.instruction-icon {
  display: inline-block;
  cursor: pointer;
  padding: 0;
  border: none;
  background: none;
}

.approvalReq-Icon {
  color: #008080;
}

.instruction-icon-svg {
  color: #008080;
  height: 1.5em !important;
  width: 2rem !important;
}

.bullet {
  margin-bottom: 5px;
}

.dashboard-instructions {
  padding: 5px;
  font-size: 12px;
  font-family: "Open Sans" !important;
}

.dashboard-instructions-header {
  font-size: 12px;
  font-weight: bold;
}

.lock-icon {
  color: rgb(88, 88, 88);
}

.page-mask {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.603);
  z-index: 9999;
}

.loader {
  position: relative;
  top: 50%;
  left: 50%;
}

.multi-select-action-btn {
  margin-right: 5px;
  border-radius: 2px;
  transition: background-color 0.2s ease;
}

.multi-select-action-btn:hover {
  background-color: #d6d6d6;
  cursor: pointer;
}

.admin-headerSearchFlex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  /* margin-bottom: 0.5rem; */
}

.signup-banner-container {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.6s ease; /* Adjust the duration and easing function as needed */
}

.visible {
  max-height: 150px;
}

.hidden {
  max-height: 0;
}

.keyboard-down-icon {
  transition: transform 0.4s !important;
}

.rotated {
  transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;uBACqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,MAAM;EACN,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC,EAAE,sDAAsD;AAC1F;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".admin-dashboard-container {\n  margin-bottom: 0px;\n  margin-top: 20px;\n  display: flex;\n}\n\n.dashboard-name {\n  margin-left: 5px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.admin-dashboard-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.admin-dashboard-header-content {\n  font-size: 20px;\n  font-weight: 400;\n  padding-left: 0px;\n  /* margin-top: 10px; */\n}\n\n.admin-dashboard-signup-banner-toggle {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #1976d2;\n}\n\n.admin-dashboard-signup-banner-toggle:hover {\n  cursor: pointer;\n  color: #1976d2;\n}\n\n.admin-dashboard-search {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  align-items: center;\n}\n\n.admin-dashboard-support-container {\n  margin-top: 20px;\n}\n\n.request-support-link {\n  color: rgb(0 151 215);\n  font-weight: 500;\n}\n\n.alert-container {\n  margin-top: 20px;\n}\n\n.table-cell-trucate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 30px;\n  font-size: 12px;\n}\n\n.table-cell-trucate-reason {\n  /* white-space: nowrap;\n    overflow: hidden; */\n  padding-left: 30px;\n  font-size: 12px;\n}\n\n.table-cell-trucate-expand {\n  white-space: nowrap;\n  overflow: hidden;\n  padding-left: 10px;\n  font-size: 12px;\n  color: blue;\n}\n\n.table-cell-trucate-expand:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.table-cell-trucate-email {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 12px;\n}\n\n.orgName-column-header {\n  padding-left: 40px !important;\n}\n\n.MuiDataGrid-cell {\n  font-size: 14px !important;\n}\n\n.MuiStepLabel-label {\n  font-size: 14px !important;\n}\n\n.instruction-icon {\n  display: inline-block;\n  cursor: pointer;\n  padding: 0;\n  border: none;\n  background: none;\n}\n\n.approvalReq-Icon {\n  color: #008080;\n}\n\n.instruction-icon-svg {\n  color: #008080;\n  height: 1.5em !important;\n  width: 2rem !important;\n}\n\n.bullet {\n  margin-bottom: 5px;\n}\n\n.dashboard-instructions {\n  padding: 5px;\n  font-size: 12px;\n  font-family: \"Open Sans\" !important;\n}\n\n.dashboard-instructions-header {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.lock-icon {\n  color: rgb(88, 88, 88);\n}\n\n.page-mask {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  background: rgba(0, 0, 0, 0.603);\n  z-index: 9999;\n}\n\n.loader {\n  position: relative;\n  top: 50%;\n  left: 50%;\n}\n\n.multi-select-action-btn {\n  margin-right: 5px;\n  border-radius: 2px;\n  transition: background-color 0.2s ease;\n}\n\n.multi-select-action-btn:hover {\n  background-color: #d6d6d6;\n  cursor: pointer;\n}\n\n.admin-headerSearchFlex {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-end;\n  /* margin-bottom: 0.5rem; */\n}\n\n.signup-banner-container {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.6s ease; /* Adjust the duration and easing function as needed */\n}\n\n.visible {\n  max-height: 150px;\n}\n\n.hidden {\n  max-height: 0;\n}\n\n.keyboard-down-icon {\n  transition: transform 0.4s !important;\n}\n\n.rotated {\n  transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
